import { tm } from '@captaincause/ui/tm'
import { CTABanner, CTABannerProps } from 'components/BlockCTABanner'
import { Markdown } from 'components/Markdown'
import CallToAction from './CallToAction'

type BasicBackground = 'light-beige' | 'black' | 'white'

export interface BasicProps {
  description: string | null
  center: boolean | null
  background: BasicBackground
  banner: CTABannerProps | null
}

const BASIC_BACKGROUND_COLORS: Record<BasicBackground, string> = {
  'light-beige': 'bg-light-beige',
  black: 'bg-black',
  white: 'bg-white',
}

export default function Basic({
  description,
  center,
  background,
  banner,
}: BasicProps) {
  if (!description) return null
  const isDark = background === 'black'

  return (
    <div
      className={tm(
        'h-auto px-4 py-12 md:px-8 md:py-20',
        BASIC_BACKGROUND_COLORS[background],
      )}
    >
      <div className="relative mx-auto flex max-w-7xl flex-col space-y-8 overflow-hidden">
        <Markdown isDark={isDark} center={!!center}>
          {description}
        </Markdown>

        {banner ? (
          <CallToAction
            title={banner.title}
            link={banner.link}
            contained
            withoutContainerPadding
          />
        ) : null}
      </div>
    </div>
  )
}
